(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TourSheetsEdit',
	};

	// Main form element
	var $form = $('form[name=TourSheetsEdit]');
	var select;

	// Serialized form data
	var serial;
	var options;
	var departureId;
	var $sidebar;
	var saveSend;

	$(document)
	.ready(
		function documentReady() {
			Adzuki.Form.registerForm(form);
		}
	);

	form.load = function load()
	{
		$sidebar           = $('.tour-sheet-sidebar');
		options            = $form.find('.tour-sheet-options');
		departureId        = $form.find('#toursheetsedit-departure_id');
		saveSend           = $form.find('#toursheetsedit-save_send');

		$(document).bind('drag-drop-files-changed', function attachmentsChanged(e, data) {
			$('#toursheetsedit-attachments_changed').val(1);
		});

		if ($(departureId).val()) {
			getDeparturePricing($(departureId).val());
		}

		departureId
		.on(
			'change',
			function getPricing(e) {
				$sidebar.empty();
				getDeparturePricing(e.target.value);
			}
		);

		options
		.on(
			'change',
			function change(e) {
				serial = options.serialize();

				if (e.target.id === 'toursheetsedit-tour_company_id') {
					$form.find('#toursheetsedit-country_id').empty();
					$form.find('#toursheetsedit-tour_id').empty();
					$form.find('#toursheetsedit-departure_id').empty();
					if (e.target.value) {
						getCountryOptions(serial);
					}
				}
				if (e.target.id === 'toursheetsedit-country_id') {
					$form.find('#toursheetsedit-tour_id').empty();
					$form.find('#toursheetsedit-departure_id').empty();
					if (e.target.value) {
						getTourOptions(serial);
					}
				}
				if (e.target.id === 'toursheetsedit-tour_id') {
					if (e.target.value) {
						getDepartureOptions(serial);
						setTourTitle(e.target);
						setTextingRecipientItemId($(e.target).val());
					} else {
						setTextingRecipientItemId('');
						$form.find('#toursheetsedit-departure_id').empty();
					}
				}
				if (e.target.id === 'toursheetsedit-departure_id') {
					setTourDate(e.target);
				}

				$.each(
					options,
					function disableEmptySelects() {
						if ($(this).attr('id') !== 'toursheetsedit-tour_company_id') {
							if ($(this).children().length === 0 && $(this).attr('type') === 'select') {
								$(this).attr('disabled', 'true');
							}
						}
					}
				);
			}
		);

		// after iFrame content loads
		$("#tour-sheets-preview").on("load", function previewLoad() {
			$('.tour-sheets-preview-loader').addClass('hidden');
			$('#tour-sheets-preview').removeClass('hidden');

			// enable send button
			$('.send-tour-sheet').prop('disabled', false);
			$('.send-tour-sheet').addClass('btn-primary');

			// enable send text button
			$('.send-tour-sheet-text').prop('disabled', false);
		});

		// Submit form when Save and Continue is clicked
		$('.btn-send').on('click', function click(e) {
			var $target = $(e.target);
			$target.addClass('disabled');

			saveSend.val('1');
			$form.submit();
		});
	};

	function getCountryOptions(serial)
	{
		Adzuki.Ajax
		.post(
			Adzuki.base_uri + '/TourSearch/getCountryOptions',
			{
				form_data: serial,
			}
		).then(
			function success(data) {
				if (data.countries) {
					setCountries(data.countries);
				}
			}
		);
	}

	function setCountries(countries)
	{
		select = $form.find('#toursheetsedit-country_id');
		select.empty();
		select.append($('<option>').text('Select Country').attr('value', ''));
		select.removeAttr('disabled');

		$.each(
			countries,
			function setCountryOptions(i, country) {
				select.append($('<option>').text(country.name).attr('value', country.id));
			}
		);
	}

	function getDeparturePricing(departureId)
	{
		Adzuki.Ajax
		.post(
			Adzuki.base_uri + '/TourSearch/getDeparturePricing',
			{
				departure_id: departureId,
			}
		).then(
			function success(data) {
				if (data) {
					getTourSheetSidebar(data.prices);
				}
			}
		);
	}

	function getTourSheetSidebar(departure_prices)
	{
		Adzuki.Ajax
		.post(
			Adzuki.base_uri + '/TourSheets/sidebar',
			{
				departure_prices: departure_prices,
			}
		).then(
			function success(sidebar) {
				if (sidebar) {
					appendTourSheetSidebar(sidebar);
				}
			}
		);
	}

	function appendTourSheetSidebar(sidebar)
	{
		$sidebar.append(sidebar);
	}

	function getTourOptions(serial)
	{
		Adzuki.Ajax
		.post(
			Adzuki.base_uri + '/TourSearch/getTourOptions',
			{
				form_data: serial,
			}
		).then(
			function success(data) {
				if (data.tours) {
					setTourOptions(data.tours);
				}
			}
		);
	}

	function setTextingRecipientItemId(item_id)
	{
		var $texting_selection = $('.edit-tour-sheet').find('.texting-selection').first();

		if ($texting_selection.length > 0) {
			$texting_selection.attr('data-item-id', item_id);
		}
	}

	function setTourOptions(tours)
	{
		select = $form.find('#toursheetsedit-tour_id');
		select.empty();
		select.append($('<option>').text('Select Tour').attr('value', ''));
		select.removeAttr('disabled');

		setTextingRecipientItemId('');

		$.each(
			tours,
			function setTourOptions(i, tour) {
				var title = tour.title;
				if (tour.season) {
					title += ' - ' + tour.season;
				}
				select.append($('<option>').html(title).attr('value', tour.slug));
			}
		);
	}

	function getDepartureOptions(serial)
	{
		Adzuki.Ajax
		.post(
			Adzuki.base_uri + '/TourSearch/getDepartureOptions',
			{
				form_data: serial,
			}
		).then(
			function success(data) {
				if (data.departures) {
					setDepartureOptions(data.departures);
				}
			}
		);
	}

	function setDepartureOptions(departures)
	{
		select = $form.find('#toursheetsedit-departure_id');
		select.empty();
		select.append($('<option>').text('Select Departure').attr('value', ''));
		select.removeAttr('disabled');

		$.each(
			departures,
			function setTourOptions(i, departure) {
				select.append($('<option>').html(departure.date).attr('value', departure.id));
			}
		);
	}

	function setTourTitle(select)
	{
		var field   = $form.find('#toursheetsedit-tour_sheet_title');
		var subject = $form.find('#toursheetsedit-subject');
		var key     = $(select).val();
		var text    = $(select).find('option[value='+key+']').text();

		$(field).val(text);
		$(subject).val(text);
	}

	function setTourDate(select)
	{
		var field = $form.find('#toursheetsedit-tour_date');
		var $field = $(field);
		var key   = $(select).val();
		var text  = key ? $(select).find('option[value='+key+']').text() : '';
		var dates = text.split('-');
		var day, month, year, min, max;

		$field.data('DateTimePicker').minDate(false);
		$field.data('DateTimePicker').maxDate(false);

		if (dates.length > '1') {
			min = new Date(dates[0].trim());
			max = new Date(dates[1].trim());

			min = min.getFullYear() +'-'+ ("0" + (min.getMonth() + 1)).slice(-2) +'-'+ ("0" + min.getDate()).slice(-2);
			max = max.getFullYear() +'-'+ ("0" + (max.getMonth() + 1)).slice(-2) +'-'+ ("0" + max.getDate()).slice(-2);

			$field.data("DateTimePicker").minDate(min);
			$field.data("DateTimePicker").maxDate(max);
		} else if (dates) {
			day   = new Date(dates[0].trim());

			year  = day.getFullYear();
			month = ("0" + (day.getMonth() + 1)).slice(-2);
			day   = ("0" + day.getDate()).slice(-2);

			$field.data("DateTimePicker").date(year+'-'+month+'-'+day);
			$field.data("DateTimePicker").minDate(year+'-'+month+'-'+day);
			$field.data("DateTimePicker").maxDate(year+'-'+month+'-'+day);
		}
	}

}(jQuery, window.Adzuki || {}));
